<template>
  <div class="energy-center-box">
	 <div :style="{
				position:'absolute',
				left:'-200px'
		  }">
		<dummynotice
		 
	  />
	 </div>
	  
    <!-- <img
      v-show="showindex == 1"
      class="imgcenter"
      src="@/assets/images/energyStorage/centerImg1.png"
      alt=""
    />
    <img
      v-show="showindex == 2"
      class="imgcenter"
      src="@/assets/images/energyStorage/centerImg2.png"
      alt=""
    />
    <img
      v-show="showindex == 3"
      class="imgcenter"
      src="@/assets/images/energyStorage/centerImg3.png"
      alt=""
    />
    <img
      v-show="showindex == 4"
      class="imgcenter"
      src="@/assets/images/energyStorage/centerImg4.png"
      alt=""
    /> -->
    <target></target>

		<!--	region zngf-dz-zhandianxinxi-zhongjian  -->
		<!--<div class="info-box">
      <div class="title">{{arrObj.solar_power_name}}</div>
      <div class="boxcell">
        <div class="left">场站类型</div>
        <div class="right">{{arrObj.photovoltaic_type}}</div>
      </div>
      <div class="boxcell">
        <div class="left">装机容量</div>
        <div class="right ycolor">{{arrObj.rated_capacity}}kw</div>
      </div>
      <div class="boxcell">
        <div class="left">光伏板数</div>
        <div class="right ycolor">{{arrObj.pvquantity}}块</div>
      </div>
    </div>-->
	  <div
		  :style="{
				position: 'absolute',top: '290px', left: '146px',

				borderRadius: '8px',
				border: '3px solid',
				borderImage: 'linear-gradient(180deg, rgba(26, 239, 239, 1), rgba(0, 0, 0, 0), rgba(26, 239, 239, 1)) 2 2',
				clipPath: 'inset(0 round 10px)',

				backgroundColor: 'rgba(6, 24, 33, 0.9)',
				backdropFilter: 'blur(24px)',

				boxSizing: 'border-box', width: '330px',
				display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start',
				padding: '16px', gap: '28px',
				fontSize: '30px', color: 'rgba(255, 255, 255, 0.9)', fontFamily: 'PingFang SC',
			}"
	  >
		  <div
			  :style="{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', gap: '12px'}"
		  >
			  <b :style="{position: 'relative', lineHeight: '38px'}">{{arrObj.solar_power_name}}</b>
			  <div
				  :style="{flexShrink: '0', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start', gap: '10px', fontSize: '18px', color: '#51dbdb'}"
			  >
				  <div :style="{position: 'relative', width: '52.6px', height: '28px'}">
					  <img
						  :style="{position: 'absolute', height: '100%', width: '100%', top: '0%', right: '0%', bottom: '0%', left: '0%', maxWidth: '100%', overflow: 'hidden', maxHeight: '100%', objectFit: 'contain'}"
						  alt=""
						  src="https://sass.gclme.com/api/file/Image/annex/20231228_b98995e2297440f39a11549c7e83642a.png"
					  />
					  <div
						  :style="{position: 'absolute', top: '1px', left: '7.6px', lineHeight: '26px'}"
					  >
						  {{arrObj.runningstate}}
					  </div>
				  </div>
				  <div
					  :style="{position: 'relative', height: '28px', color: '#f3d68e'}"
				  >
					  <img
						  :style="{
								position: 'absolute',
							  height: '100%', width: '100%',
							  objectFit: 'fill',transform: 'scale(1.2,1)'
							}"
						  alt=""
						  src="https://sass.gclme.com/api/file/Image/annex/20231228_58cbfbc6ba18435b9dce9a0f8faa67ca.png"
					  />
					  <div
						  :style="{lineHeight: '26px'}"
					  >
						  {{arrObj.photovoltaic_type}}
					  </div>
				  </div>
			  </div>
		  </div>
		  <div
			  :style="{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', gap: '12px', fontSize: '18px', color: 'rgba(255, 255, 255, 0.7)'}"
		  >
			  <div
				  :style="{flexShrink: '0', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start'}"
			  >
				  <div :style="{position: 'relative', lineHeight: '26px'}">
					  场站类型：
				  </div>
				  <div
					  :style="{position: 'relative', lineHeight: '26px', color: 'rgba(255, 255, 255, 0.9)'}"
				  >
					  {{arrObj.photovoltaic_type}}
				  </div>
			  </div>
			  <div
				  :style="{flexShrink: '0', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start'}"
			  >
				  <div :style="{position: 'relative', lineHeight: '26px'}">
					  装机容量：
				  </div>
				  <div
					  :style="{position: 'relative', lineHeight: '26px', color: 'rgba(255, 255, 255, 0.9)'}"
				  >
					  {{arrObj.rated_capacity}}kw
				  </div>
			  </div>
			  <div
				  :style="{flexShrink: '0', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-start'}"
			  >
				  <div :style="{position: 'relative', lineHeight: '26px'}">
					  光伏板数量：
				  </div>
				  <div
					  :style="{position: 'relative', lineHeight: '26px', color: 'rgba(255, 255, 255, 0.9)'}"
				  >
					  {{arrObj.pvquantity}}块
				  </div>
			  </div>
		  </div>
	  </div>
		<!-- endregion -->

		<div class="bottom-notice-p">
			<Com_center_bottom2></Com_center_bottom2>
		</div>
  </div>
</template>

<script>
import target from "@/views/components/energyStorage/target.vue";
import { dataInterface } from "@/api/dataInterfaceApi";
import dummynotice from '@/views/components/exposition/titlenum.vue'
// import Com_center_bottom from "@/views/components/photovoltaicStation/Com_center_bottom.vue";
import Com_center_bottom2 from "@/views/components/photovoltaicStation/Com_center_bottom2.vue";
export default {
  components: {
    dummynotice,
		// Com_center_bottom,
	  Com_center_bottom2
  },
  data() {
    return {
      showindex: 1,
      arrObj: {}
    };
  },
  mounted() {
    this.initData()
  },
  methods: {
	  initData() {
	    let params = {
        "enCode": "zngf-dz-zhandianxinxi-zhongjian",// 接口code
        "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
	    }
	    this.showcdata = false;
	    let that = this
	    dataInterface
	      .dataFaceApi(params)
	      .then((res) => {
	        console.log("中间光伏站信息 res:",res);
	        if (res && res[0]) {
						this.arrObj = res[0]
					}
	      })
	      .catch((err) => {
	        console.log(err);
	      });
	  },
  },
};
</script>

<style scoped lang="scss">
@import "@/views/components/energyStorage/comm.scss";
.energy-center-box {
  width: 1440px;
  height: 1470px;
  margin-top: 100px;
  position: relative;
  .imgcenter {
    width: 1210px;
    height: 750px;
    position: absolute;
    left: 50%;
    margin-left: -605px;
    top: 50%;
    margin-top: -420px;
  }
  .info-box {
    position: absolute;
    left: 146px;
    top: 290px;
    width: 381px;
    background: rgba(0, 15, 31, 0.8);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid rgba(53, 250, 254, 0.4);
    padding: 15px 15px 5px 15px;
    .title {
      letter-spacing: 2px;
      width: 297px;
      line-height: 50px;
      padding-left: 8px;
      // font-weight: 600;
      background: linear-gradient(
        90deg,
        #35fbfe -140%,
        rgba(53, 251, 254, 0) 100%
      );
      border-radius: 0px 0px 0px 0px;
      font-size: 32px;
      opacity: 1;
      font-family: "PMZD";
      margin-bottom:10px ;
    }
    .boxcell {
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      padding: 5px 10px;
      font-size: 20px;
      .right {
        text-align: right;
        
        font-family: "PMZD";
      }
      .left{

      }
      .ycolor {
        color: #ffd15c;
        // font-weight: 600;
      }
    }
  }
  .dv-scroll-board ::v-deep .header {
    font-size: $FontSize20;
  }
  .dv-scroll-board ::v-deep .rows .row-item {
    font-size: $FontSize20;
  }
  .bottom-notice-p{
	  width: 1100px;
	  height: 200px;
	  position: absolute;
	  left: 50%;
	  margin-left: -550px;
	  bottom: 140px;
  }
}
</style>